import * as types from '../types/similarTypes';

const initialState = {
  results: [],
  loading: false,
  error: null,
  voteSubmittingId: null,
};

export default function similarReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SIMILAR_REQUEST:
      return { ...state, loading: true, error: null, results: [] };
    case types.FETCH_SIMILAR_SUCCESS:
      return { ...state, loading: false, results: action.payload || [] };
    case types.FETCH_SIMILAR_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.VOTE_SUBMIT_START:
      return { ...state, voteSubmittingId: action.payload };
    case types.VOTE_SUBMIT_END:
      return { ...state, voteSubmittingId: null };
    default:
      return state;
  }
}
